import React from 'react'
import Product_ifile11 from './Product_ifile11'
// import Product_ifile12 from './Product_ifile12'
import Product_ifile13 from './Product_ifile13'
// import Product_ifile14 from './Product_ifile14'
import Product_ifile15 from './Product_ifile15'
import Product_ifile16 from './Product_ifile16'
import Product_ifile17 from './Product_ifile17'
import Product_ifile18 from './Product_ifile18'
import Product_ifile19 from './Product_ifile19'
// import Product_ifile20 from './Product_ifile20'
import Product_ifile21 from './Product_ifile21'
import Gfooter from '../Component/Gfooter'
import Product_ifile22 from './Product_ifile22'
// import Product_ifile23 from './Product_ifile23'
// import Product_ifile24 from './Product_ifile24'
// import Product_ifile25 from './Product_ifile25'
import ITixfeatures from './ITixfeatures'
import Product_ifile26 from './Product_ifile26'
// import Ifile_Footer from './Ifile_Footer'
// import Ifile_UseCases from './IfileUseCases'
import Product_ifile27 from './Product_ifile27'
import ITixplatform from './Itixplatform'
import ITixtagline from './ITixtagline'
import ITixcontact from './ITixcontact'

function Product_ifile1() {
  return (
    <>
    <Product_ifile11/>
    {/* <Product_ifile12/> */}
    <Product_ifile22/>
    {/* <Product_ifile24/> */}
    {/* <Product_ifile23/> */}
    <ITixfeatures/>
    <Product_ifile26/>
    {/* <Product_ifile13/> */}
    {/* <Product_ifile14/> */}
    {/* <Product_ifile15/> */}
    {/* <Product_ifile16/> */}
    {/* <Product_ifile17/> */}
    {/* <Product_ifile18/> */}
    {/* <Product_ifile19/> */}
    {/* <Product_ifile20/> */}
    <Product_ifile27/>
    {/* <Ifile_UseCases/> */}
    {/* <Product_ifile21/> */}
    {/* <Ifile_Footer/> */}
    <ITixplatform/>
    <ITixtagline/>
    <ITixcontact/>
    <Gfooter/>
    </>
  )
}

export default Product_ifile1
